import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import {
  handleJobQueuedSuccess,
  handleJobRequestError,
} from '../../../helpers/cpanelJobFeedback';
import CpanelPageShell from '../../../components/cpanel/CpanelPageShell';
import ActionBarCpanelTenantComp from '../../../components/moleculs/cpanel/tenants/action-bar';
import CreateCpanelTenantComp from '../../../components/moleculs/cpanel/tenants/create';
import DatatableCpanelTenants from '../../../components/moleculs/cpanel/tenants/datatable';
import EditCpanelTenantComp from '../../../components/moleculs/cpanel/tenants/edit';
import ShowCpanelTenantComp from '../../../components/moleculs/cpanel/tenants/show';
import ImportCpanelTenantComp from '../../../components/moleculs/cpanel/tenants/import';
import ExportCpanelTenantComp from '../../../components/moleculs/cpanel/tenants/export';

const CpanelTenantsPage = () => {
  const [search, setSearch] = useState('');
  const [tenants, setTenants] = useState([]);
  const [filterTenants, setFilterTenants] = useState([]);
  const [editTenant, setEditTenant] = useState(null);
  const [showTenant, setShowTenant] = useState(null);
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowDetail, setLgShowDetail] = useState(false);
  const [lgShowImport, setLgShowImport] = useState(false);
  const [lgShowExport, setLgShowExport] = useState(false);
  const [lgShowUpdate, setLgShowUpdate] = useState(false);

  const fetchTenants = async () => {
    try {
      const { data } = await axios({
        url: '/cpanel/tenants/list',
        method: 'GET',
      });
      setTenants(data || []);
      setFilterTenants(data || []);
    } catch (err) {
      console.log(err);
      MySwal.fire({
        icon: 'error',
        title: 'Gagal memuat data',
        text: err?.response?.data?.message || 'Tidak dapat mengambil daftar tenant.',
      });
    }
  };

  const runDeleteTenant = async (id, hardDelete) => {
    try {
      const response = await axios.delete(`/cpanel/tenants/delete/${id}`, {
        params: { hard: hardDelete },
      });

      const queued = await handleJobQueuedSuccess({
        response,
        actionLabel: hardDelete ? 'Penghapusan permanen tenant' : 'Penghapusan tenant',
        fetch: fetchTenants,
      });

      if (!queued) {
        MySwal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: response.data?.message || 'Tenant berhasil dihapus.',
        });
        fetchTenants();
      }
    } catch (err) {
      handleJobRequestError(err, 'Gagal memulai penghapusan tenant.');
    }
  };

  const handleHapusTenant = async (row) => {
    const { value: deleteMode } = await MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: `Tenant: ${row.slug}`,
      input: 'radio',
      inputOptions: {
        soft: 'Hapus Sementara',
        hard: 'Hapus Permanen',
      },
      inputValue: 'hard',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Lanjutkan',
      cancelButtonText: 'Batal',
      inputValidator: (value) => {
        if (!value) return 'Pilih jenis penghapusan';
        return undefined;
      },
    });

    if (!deleteMode) return;

    if (deleteMode === 'hard') {
      const confirmHard = await MySwal.fire({
        title: 'Hapus Permanen?',
        text: 'Data tidak dapat dikembalikan.',
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Ya, hapus permanen',
        cancelButtonText: 'Batal',
      });

      if (!confirmHard.isConfirmed) return;
    } else {
      const confirmSoft = await MySwal.fire({
        title: 'Hapus Sementara?',
        text: 'Tenant akan dihapus dari daftar aktif.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Ya, hapus sementara',
        cancelButtonText: 'Batal',
      });

      if (!confirmSoft.isConfirmed) return;
    }

    await runDeleteTenant(row.id, deleteMode === 'hard');
  };

  const handleShowTenant = (row) => {
    setShowTenant(row);
    setLgShowDetail(true);
  };

  const handleEditTenant = (row) => {
    setEditTenant(row);
    setLgShowUpdate(true);
  };

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  useEffect(() => {
    fetchTenants();
  }, []);

  useEffect(() => {
    const keyword = search.toString().toLowerCase();
    const result = tenants.filter((item) => {
      const slug = (item.slug || '').toLowerCase();
      const accessPath = slug ? `/hospitals/${slug}` : '';
      const stored = (item.stored || '').toLowerCase();
      const description = (item.description || '').toLowerCase();
      return (
        accessPath.includes(keyword) ||
        slug.includes(keyword) ||
        stored.includes(keyword) ||
        description.includes(keyword)
      );
    });
    setFilterTenants(result);
  }, [search, tenants]);

  return (
    <>
      <CpanelPageShell
        title="Tenant"
        subtitle="Kelola rumah sakit"
        actions={
          <ActionBarCpanelTenantComp
            showFormAdd={() => setLgShowAdd(true)}
            showFormImport={() => setLgShowImport(true)}
            showFormExport={() => setLgShowExport(true)}
          />
        }
      >
        <div className="card">
          <div className="card-body">
            <DatatableCpanelTenants
              listTenants={filterTenants}
              search={search}
              handleChangeSearch={handleChangeSearch}
              handleShowTenant={handleShowTenant}
              handleEditTenant={handleEditTenant}
              handleHapusTenant={handleHapusTenant}
            />
          </div>
        </div>
      </CpanelPageShell>

      <Modal show={lgShowAdd} onHide={() => setLgShowAdd(false)} backdrop="static" keyboard={false} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Tambah Tenant</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateCpanelTenantComp close={() => setLgShowAdd(false)} fetch={fetchTenants} />
        </Modal.Body>
      </Modal>

      <Modal show={lgShowImport} onHide={() => setLgShowImport(false)} backdrop="static" keyboard={false} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Impor Tenant</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ImportCpanelTenantComp close={() => setLgShowImport(false)} fetch={fetchTenants} />
        </Modal.Body>
      </Modal>

      <Modal show={lgShowExport} onHide={() => setLgShowExport(false)} backdrop="static" keyboard={false} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Ekspor Tenant</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ExportCpanelTenantComp close={() => setLgShowExport(false)} />
        </Modal.Body>
      </Modal>

      <Modal show={lgShowDetail} onHide={() => setLgShowDetail(false)} backdrop="static" keyboard={false} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Detail Tenant</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ShowCpanelTenantComp
            tenant={showTenant}
            close={() => setLgShowDetail(false)}
          />
        </Modal.Body>
      </Modal>

      <Modal show={lgShowUpdate} onHide={() => setLgShowUpdate(false)} backdrop="static" keyboard={false} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Tenant</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditCpanelTenantComp
            editTenant={editTenant}
            close={() => setLgShowUpdate(false)}
            fetch={fetchTenants}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CpanelTenantsPage;
